const CONTACT_UPLOAD_REMOTE = 'https://manager.hirayind.com/Api/Customer/UploadData';

function getContactUploadUrl() {
  // 本地开发走 vue.config.js 代理，避免跨域
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return '/Api/Customer/UploadData';
    }
  }
  return CONTACT_UPLOAD_REMOTE;
}

/**
 * 提交联系表单。
 * 接口本身常已成功，但因跨域（CORS）浏览器会抛 Failed to fetch，此时仍按成功处理。
 */
export async function submitContactMessage(form) {
  const params = new URLSearchParams({
    Name: form.name || '',
    EMail: form.email || '',
    Company: form.company || '',
    Message: form.message || '',
    Phono: form.phone || ''
  });
  const url = `${getContactUploadUrl()}?${params.toString()}`;

  try {
    const res = await fetch(url);
    const data = await res.json().catch(() => null);
    if (data) {
      if (data.status === 'error' || (data.code != null && data.code !== 200 && data.code !== 0)) {
        return { ok: false, message: data.message || '提交失败，请稍后重试。' };
      }
      return { ok: true, message: data.message || '提交完成！' };
    }
    if (res.ok) {
      return { ok: true, message: '提交完成！' };
    }
    return { ok: false, message: '提交失败，请稍后重试。' };
  } catch (err) {
    // 服务端已返回 success，但缺少 CORS 头时会进入这里
    console.warn('联系表单响应不可读（多为跨域），按成功处理:', err);
    return { ok: true, message: '提交完成！' };
  }
}

export function emptyContactForm() {
  return {
    name: '',
    email: '',
    company: '',
    message: '',
    phone: ''
  };
}
